<template>
  <fieldset class="border rounded m-2 px-2 pt-2">
    <div class="flex items-center mx-1 mb-2">
      電子報發送設定
    </div>
    <vxe-form class="" ref="form" :data="table.formData" :rules="table.rules" titleAlign="right" @submit="table.save">
      <vxe-form-item title="類型" field="type" :item-render="{}" span="24">
        <template #default="{ data }">
          <vxe-radio-group v-model="data.type" @change="changeType">
            <vxe-radio :label="0" content="全部發送"></vxe-radio>
            <vxe-radio :label="1" content="自訂名單"></vxe-radio>
          </vxe-radio-group>
        </template>
      </vxe-form-item>
      <!-- <vxe-form-item title="活動選擇" field="activityId" :item-render="{}" span="12" v-if="paperType == 2">
        <template #default="{ data }">
          <vxe-select v-model="data.activityId" placeholder="活動選擇">
            <vxe-option :key="0" :value="0" :label="`請選擇活動`"></vxe-option>
            <vxe-option v-for="item in list" :key="item.value" :value="item.value" :label="`${item.label}`"></vxe-option>
          </vxe-select>
        </template>
      </vxe-form-item> -->
      <!-- <vxe-form-item title="類型" field="id" :item-render="{}" span="24">
        <template #default="{ data }">
          <vxe-checkbox-group v-model="data.id" :disabled="data.type == 1">
            <vxe-checkbox v-for="item in list" :key="item.value" :label="item.value" :content="item.label"></vxe-checkbox>
          </vxe-checkbox-group>
        </template>
      </vxe-form-item> -->
      <vxe-form-item title="會員選擇" field="id" :item-render="{}" span="24">
        <template #default="{ data }">
          <select-box
            class="custom-vue-selector"
            :readonly="data.type == 0"
            v-bind="memberSelectorOptions"
            v-model="data.members"
          />
        </template>
      </vxe-form-item>
      <vxe-form-item title="Email" field="emails" :item-render="{}" span="24">
        <template #default="{ data }">
          <div class="w-full custom-vue-selector">
            <div class="relative">
              <div class="mr-6">
                <vue-tags-input
                  :placeholder="`請輸入Email`"
                  class=""
                  v-model="customeEmail"
                  :disabled="data.type == 0"
                  :readonly="data.type == 0"
                  :tags="tags"
                  :validation="validation"
                  @tags-changed="newTags => tags = newTags"
                />
              </div>
            </div>
          </div>
        </template>
      </vxe-form-item>
      <vxe-form-item class-name="text-left" :item-render="{}" span="24">
          <template #default>
            <vxe-button class="" type="submit" status="primary" content="確認" :disabled="isDisabled">
            </vxe-button>&nbsp;
            <span v-if="isDisabled" class-name="px-1 text-xl" style="color:IndianRed;">電子報發送程序處理中...</span>
          </template>
      </vxe-form-item>
    </vxe-form>
  </fieldset>
  <!-- <div class="flex flex-col sm:flex-row sm:items-end xl:items-start">
        <div class="xl:flex sm:mr-auto">
          <div class="sm:flex items-center ml-1 sm:mr-2 mt-2 xl:mt-0">
            <input type="search" class="input w-full sm:w-40 xxl:w-full mt-2 sm:mt-0 border" v-model.trim="grid.keyword" placeholder="請輸入關鍵字" />
          </div>
          <div class="mt-2 xl:mt-0">
            <button type="button" class="button w-full sm:w-16 bg-theme-1 text-white" @click="grid.refresh">
              搜尋
            </button>
          </div>
        </div>
        <div class="flex justify-end mr-2">
            <button v-if="grid && !grid.isEditing" class="button text-white bg-green-500 shadow-md flex items-center mb-2 mr-2" @click="send">
              發行優惠
            </button>
            <button v-if="grid && !grid.isEditing" class="button text-white bg-theme-1 shadow-md flex items-center mb-2 mr-2" @click="recordModal.show">
              發行紀錄
            </button>
            <button v-if="grid && !grid.isEditing" class="button text-white bg-red-500 shadow-md flex items-center mb-2" @click="deleteAll">
              清除列表
            </button>
        </div>
  </div> -->
  <div class="w-full flex xl:flex-row sm:flex-col xl:justify-end">
    <!-- <button v-if="grid && !grid.isEditing" class="button text-white bg-green-500 shadow-md flex items-center mb-2 mr-2" @click="send">
      發行優惠
    </button>
    <button v-if="grid && !grid.isEditing" class="button text-white bg-theme-1 shadow-md flex items-center mb-2 mr-2" @click="recordModal.show">
      發行紀錄
    </button>
    <button v-if="grid && !grid.isEditing" class="button text-white bg-red-500 shadow-md flex items-center mb-2" @click="deleteAll">
      清除列表
    </button> -->
    <!-- <button v-show="!grid.isEditing" class="button text-white bg-theme-1 shadow-md mr-2 my-2 flex items-center" @click="grid.addNewRow">
      <FontAwesome icon="plus" type="fas" class="w-4 h-4 mr-1" />
      新增
    </button> -->
  </div>
  <Grid ref="grid" v-bind="gridOptions"
    @addNewRow="initData"
    @removeSelectedRows="hideBatchDropDown()"
    @edit="onGridEdit"
  >
    <template #send="{ row }">
      <vxe-button type="button" content="發行" @click="singleSend(row.Id)"></vxe-button>
    </template>
    <template #modal="{ row, submit, reset }">
      <vxe-form
        class="ml-3"
        ref="sessionForm"
        v-bind="formOptions"
        :data="row"
        @reset="reset"
        @submit="submit">
      </vxe-form>
    </template>
    <template #modal-footer>
      <vxe-button type="submit" status="primary" content="確認" @click="close"></vxe-button>
    </template>
  </Grid>

</template>
<script lang="ts">
/* eslint-disable */
import CloudFun, { Condition, defineComponent, Operator, ref, reactive, Sorting, SortOrder, PropType, onMounted } from '@cloudfun/core'
import Grid, { GridOptions } from '@/cloudfun/components/Grid.vue'
import { VxeFormProps, VxeTableProps } from 'vxe-table'
import formatDate from 'xe-utils/toDateString'
import { watch } from 'vue-demi';
import RecordTable from "@/components/coupon-set/RecordTable.vue";
import SelectBox, {
  SelectBoxOptions
} from "@/cloudfun/components/SelectBox.vue";
import VueTagsInput from "@sipec/vue3-tags-input";

export default defineComponent({
  components: {
    Grid,
    RecordTable,
    SelectBox,
    VueTagsInput,
  },
  props: {
    sid: Number,
    paperType: Number,
    modelValue: Boolean,
    promises: Object as PropType<{
      /** 非同步查詢 */
      query?: (params: {
        page: number;
        pageSize: number;
        keyword?: string;
        sortings?: Sorting[];
        condition?: Condition;
      }) => Promise<{ data: any[]; totalCount: number }>;
      /** 查詢所有資料 */
      queryAll?: (params?: {
        keyword?: string;
        sortings?: Sorting[];
        condition?: Condition;
      }) => Promise<any[]>;
      /** 儲存已變更資料 */
      save?: (params: {
        insertRows?: any[];
        updateRows?: any[];
        deleteRows?: any[];
      }) => Promise<void>;
    }>
  },
  setup(props) {
    const model = CloudFun.current?.model
    const grid = ref<any>({});
    const isDisabled = ref(false);
    const gridOptions: GridOptions = {
      title: '發行紀錄',
      canCreate: false,
      canUpdate: false,
      canDelete: false,
      multiselect: false,
      showFooter: true,
      columns: [
        { field: 'CreatedTime', title: '建立時間', showOverflow: true, sortable: true, resizable: false, formatter: ({ cellValue }) => cellValue ? formatDate(new Date(cellValue), 'yyyy/MM/dd HH:mm:ss') : '' },
        { field: 'Subject', title: '主旨', showOverflow: true, sortable: true, resizable: false },
        { field: 'Message', title: '發送訊息', showOverflow: true, sortable: true, resizable: false },
      ],
      promises: { query: props.promises?.query, queryAll: props.promises?.queryAll, save: props.promises?.save },
      modalConfig: { width: "50%", height: "550", showFooter: true },
    }


    const formOptions: VxeFormProps = {
      titleWidth: 100,
      titleAlign: 'right',
      items: [
      { field: 'CreatedTime', title: '建立時間', span: 12, itemRender: { name: '$input', props: { type: 'date', labelFormat: 'yyyy/MM/dd HH:mm:ss' } } },
        { field: 'Id', title: '資料ID', span: 12, itemRender: { name: '$input' } },
        { field: 'Subject', title: '主旨', span: 24, itemRender: { name: '$input' } },
        { field: 'Message', title: '發送訊息', span: 24, itemRender: { name: '$input' } },
        { field: 'Recipient', title: '發送Email', span: 24, itemRender: { name: '$textarea', props: { autosize: { minRows: 4, maxRows: 4, type: 'string' } }, attrs: { type: 'textarea' } } },
        { field: 'Body', title: '郵件內容', span: 24, itemRender: { name: '$textarea', props: { autosize: { minRows: 4, maxRows: 4, type: 'string' } }, attrs: { type: 'textarea' } } },
        ],
      rules:{
        Name: [{ type: 'string', required: true }],
        Date: [{ type: 'string', required: true }],
      }
    }

    const initData = (row: any, callback: any) => {
      callback();
    }

    const deleteAll = () => {
      if(confirm("確定要清除折扣優惠列表嗎?")) {
        if(props.sid) {        
          model?.dispatch('coupon/deleteAll', props.sid).then(() => {
            CloudFun.send("info", {
              subject: "執行成功",
              content: "刪除所有折扣優惠",
            });
            grid.value.refresh();
          }).catch((error) =>{
            console.log(error)
            CloudFun.send("error", {
              subject: "執行失敗",
              content: error,
            });
          })
        } else {
          CloudFun.send("error", {
            subject: "執行失敗",
            content: "無法取得折扣資料",
          });
        }
      }
    }

    const send = () => {
      if(confirm("確定要發行嗎?")) {
        if(props.sid) {
          model?.dispatch('coupon/send', props.sid).then(() => {
            CloudFun.send("info", {
              subject: "執行成功",
              content: "已發行完成",
            });
            grid.value.refresh();
          }).catch((error) =>{
            console.log(error)
            CloudFun.send("error", {
              subject: "執行失敗",
              content: error,
            });
          })
        } else {
          CloudFun.send("error", {
            subject: "執行失敗",
            content: "無法取得折扣資料",
          });
        }
      }
    }

    const singleSend = (id: any) => {
      if(confirm("確定要發行折扣優惠嗎?")) {
        if(id) {
          model?.dispatch('coupon/singleSend', id).then(() => {
            CloudFun.send("info", {
              subject: "執行成功",
              content: "已發行完成",
            });
            grid.value.refresh();
          }).catch((error) =>{
            console.log(error)
            CloudFun.send("error", {
              subject: "執行失敗",
              content: error,
            });
          })
        } else {
          CloudFun.send("error", {
            subject: "執行失敗",
            content: "無法取得折扣資料",
          });
        }
      }
    }
    
    const memberSelectorOptions: SelectBoxOptions = {
      rowId: "Id",
      transfer: true,
      placeholder: "選擇會員",
      textField: "Name",
      valueField: "Id",
      multiselect: true,
      formatText: (row) => row?.Name ? row.Name : row.Organization?.Name,
      columns: [
        {
          field: "Account",
          title: "Email",
          showHeaderOverflow: true,
          showOverflow: true,
          sortable: true
        },
        {
          field: "Name",
          title: "姓名",
          showHeaderOverflow: true,
          showOverflow: true,
          sortable: true,
          formatter: ({ row, cellValue }) => cellValue ?? row.Organization?.Name,
        },
      ],
      showHeader: true,
      promises: {
        find: value => model!.dispatch("member/find", value), // eslint-disable-line
        query: params => model!.dispatch("member/options", params) // eslint-disable-line
      }
    };

    const tags = ref([]);
    const customeEmail = ref('');
    
    const table = reactive({
      data: {} as any,
      isLoading: false,
      isEditing: false,
      formData: { id: [], members: [], type: 0, activityId: 0 } as any,
      selectedRow: null as any | null,
      async save() {
        //活動判斷
        // if(props.sid == 2 && table.formData.activityId <= 0) {
        //   CloudFun.send("error", {
        //     subject: "執行失敗",
        //     content: "請選擇活動！",
        //   });
        //   return;
        // }

        if(table.formData.type == 1 && table.formData.members.length <= 0 && tags.value.length <= 0) {
          CloudFun.send("error", {
            subject: "執行失敗",
            content: "請選擇會員或輸入Email！",
          });
          return;
        }
        var emails = [] as any;
        if(tags.value && tags.value.length > 0) {
          emails = tags.value.filter((e: any) => e.text).map((e: any) => e.text);
        }
        const data = {
          id: props.sid,
          memberIds: table.formData.members,
          emails: emails,
          activityId: table.formData.activityId,
          typeId: table.formData.type,
        }
        console.log(data);
        isDisabled.value = true;
        await model?.dispatch('epaper/send', data).then(() => {
          CloudFun.send("info", {
              subject: "執行成功",
              content: "已發行完成",
            });
            grid.value.refresh();
            isDisabled.value = false;
          }).catch((error) =>{
            console.log(error)
            isDisabled.value = false;
            CloudFun.send("error", {
              subject: "執行失敗",
              content: error,
            });
         })
      },
    })

    const getActivity = async(id: any) => {
      var params = {
        condition: new Condition('Published', Operator.Equal, true).and('EpaperId', Operator.IsNotNull).and('EpaperId.Value', Operator.Equal, id.toString())
      };
      return model?.dispatch('activity/options', params).then((data) => {
        return data;
      }).catch((error) =>{
        console.log(error)
      })
    }


    const form = ref<any>();
    const list = ref<any[]>([]);
    onMounted(async()=> {
      table.formData.activityId = 0;
      if(props.paperType == 2) {
        list.value = await getActivity(props.sid);
        console.log(list.value);
      }
    })

    watch(() => props.modelValue, async (val) => {
      //console.log(val)
      if(val) {
        table.formData.id = [];
        table.formData.members = [];
        table.formData.type = 0;
        table.formData.activityId = 0;
        customeEmail.value = '';
        tags.value = [];
        if(props.paperType == 2) {
          list.value = await getActivity(props.sid);
          console.log(list.value);
        }
      }
    })


    const onGridEdit = (row: any, callback: any) => {
      // const entity = row.Id ? await this.$model.dispatch('documentRecord/find', row.Id) : undefined
      // Object.assign(row, entity)
      // const statuses = (Object.values(this.$model.enums.DocumentStatus) as any[]);
      // row.BeforeStatusName = statuses.find(e => e.Value === row.BeforeStatus).Name;
      // row.AfterStatusName = statuses.find(e => e.Value === row.AfterStatus).Name;
      //   if (entity) {
      //     entity.Xml.Time = new Date(entity.Xml.Time)
      //   }
      callback()
    }

    const changeType = () => {
      if(table.formData.type == 0) {
        table.formData.members = [];
        customeEmail.value = '';
        tags.value = [];
      } else {
        table.formData.id = [];
      }
    }

    const close = () => {
      grid.value.isModalPopup = false;
    }

    return {
      grid,
      initData,
      gridOptions,
      formOptions,
      deleteAll,
      send,
      singleSend,
      list,
      form,
      table,
      onGridEdit,
      changeType,
      memberSelectorOptions,
      customeEmail,
      close,
      tags,
      isDisabled,
      validation: [{
        classes: 'avoid-item',
        rule: (customeEmail: { text: string|any[]; }) => !(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(customeEmail.text.toString())),
        disableAdd: true,
      }],
    }
  },
  methods: {
    refresh() {
      (this.$refs.grid as any).refresh();
    },    
    hideBatchDropDown () {
      cash('#batch-dropdown').dropdown('hide')
    },
  }
});
</script>

<style scoped>
.custom-vue-selector :deep(.vue-tags-input.ti-disabled) {
  background-color: #f3f3f3;
}
.vxe-form--item.is--error .custom-vue-selector :deep(.vue-tags-input .ti-input) {
  border-color: #f56c6c !important;
}

</style>
